const ACTIVITY_KEY = "activity";
const MAX_ACTIVITY = 30;

const safeParse = (value, fallback) => {
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

export const readActivity = () => {
    if (typeof window === "undefined") return [];
    return safeParse(window.localStorage.getItem(ACTIVITY_KEY), []);
};

export const pushActivity = (entry) => {
    if (typeof window === "undefined") return;
    const now = Date.now();
    const next = [
        {
            id: `${entry.type || "activity"}-${now}-${Math.random().toString(36).slice(2, 8)}`,
            ts: entry.ts || now,
            ...entry,
        },
        ...readActivity(),
    ].slice(0, MAX_ACTIVITY);

    window.localStorage.setItem(ACTIVITY_KEY, JSON.stringify(next));
};
